import { useState } from "react";
import { Modal } from "antd";
import FolderContent from "./folder-content-modal/FolderContent";
import "./Folder.css";

const Folder = ({ title, items }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="folder-container">
      {/* Folder UI */}
      <div
        className="folder"
        onClick={() => setOpen(true)}
      >
        <div className="folder-icon">
          <div className="folder-top" />
          <div className="folder-body" />
        </div>
        <span className="folder-title">{title}</span>
      </div>

      {/* Modal for apps */}
      <Modal
        open={open}
        className="modal"
        onCancel={() => setOpen(false)}
        footer={null}
        width={700}
        centered
        style={{ padding: "1.5rem" }}
      >
        {
          title === "Education" ?
            (
              <div class="timeline">
                <h4>Education & Experience</h4>

                <div class="timeline-item">
                  <span class="date">2021 – 2025</span>
                  <p>University of Calgary — Graduation</p>
                </div>

                <div class="timeline-item">
                  <span class="date">May 2024 – Sept 2024</span>
                  <p>FPT — Internship</p>
                </div>

                <div class="timeline-item">
                  <span class="date">May 2025 - Present</span>
                  <p>Alpaca — Full Time</p>
                </div>
              </div>
            ) :
            <FolderContent
              title={title}
              apps={items}
              onClose={() => setOpen(false)}
            />
        }

      </Modal>
    </div>
  );
};

export default Folder;
